import { ApiRequest } from '@/helpers';

export const reactions = {
  namespaced: true,
  state: getInitialState(),
  actions: {
    async fetch({ commit }, { recordingId }) {
      const { data } = await ApiRequest({
        method: 'get',
        url: `/recordings/${recordingId}/reactions`,
      });
      const reactions = data.reactions;

      commit('setReactions', {
        recordingId,
        reactions,
      });
      return reactions;
    },
    async fetchIfNeeded({ state, dispatch }, data) {
      if (!state.reactions[data.recordingId]) {
        await dispatch('fetch', data);
      }
      return state.reactions[data.recordingId];
    },
    async react(
      { commit, rootState, getters },
      { recordingId, entityId, entityType, value }
    ) {
      const reaction = {
        entityId,
        entityType,
        value,
        uid: rootState.currentUser.uid,
      };
      const reactionIndex = getters.getReactionIndex(recordingId, reaction);
      if (reactionIndex !== -1) {
        commit('removeReaction', {
          recordingId,
          reactionIndex,
        });
      } else {
        commit('addReaction', {
          recordingId,
          reaction,
        });
      }
      const response = await ApiRequest({
        method: reactionIndex === -1 ? 'post' : 'delete',
        url: `${import.meta.env.VITE_API_URL}/recordings/${recordingId}/reactions`,
        data: {
          entityId,
          entityType,
          value,
        },
      });
      const reactions = response.data.reactions;
      return reactions;
    },
  },
  mutations: {
    setReactions(state, { recordingId, reactions }) {
      state.reactions[recordingId] = reactions;
    },
    addReaction(state, { recordingId, reaction }) {
      if (!state.reactions[recordingId]) {
        state.reactions[recordingId] = [reaction];
      } else {
        state.reactions[recordingId] = [
          ...state.reactions[recordingId],
          reaction,
        ];
      }
    },
    removeReaction(state, { recordingId, reactionIndex }) {
      state.reactions[recordingId].splice(reactionIndex, 1);
    },
    resetState(state) {
      Object.assign(state, getInitialState());
    },
  },
  getters: {
    get: (state) => (recordingId) => state.reactions[recordingId],
    getForEntity: (state) => (recordingId, entityType, entityId) => {
      if (!state.reactions[recordingId]) {
        return null;
      }
      const reactions = state.reactions[recordingId].filter(
        (r) => r.entityId === entityId && r.entityType === entityType
      );
      if (reactions.length === 0) {
        return null;
      }
      const groupedReactions = Object.groupBy(reactions, (r) => r.value);
      return groupedReactions;
    },
    getReactionIndex: (state) => (recordingId, reaction) => {
      if (!state.reactions[recordingId]) {
        return -1;
      }
      return state.reactions[recordingId].findIndex(
        (r) =>
          r.uid === reaction.uid &&
          r.value === reaction.value &&
          r.entityType === reaction.entityType &&
          r.entityId === reaction.entityId
      );
    },
  },
};

function getInitialState() {
  return {
    reactions: {},
  };
}
